interface GetPaginationOffsetArgs {
  page: number,
  limit: number,
}

interface GetPaginationOffset {
  (args: GetPaginationOffsetArgs): number
}

const getPaginationOffset: GetPaginationOffset = ({ page, limit }) => page * limit - limit;

export default getPaginationOffset;